import React, { PureComponent, Fragment } from 'react'
import { Grid, TableRow, TableCell, MenuItem, Typography } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { onChangeEditHOF } from '../../utils/common'
import { isValidString } from '../../utils/string'
import { hasAccess } from '../../utils/api'
import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import ModalDialog from '../../components/common/ModalDialog'

class OnFleetShopInfoItem extends PureComponent {
  onChange = onChangeEditHOF(this.props.onChange)

  enableEdit = () => {
    const { data } = this.props
    if (data.onFleetApiKey) this.props.fetchHubList(data.onFleetApiKey, false)
    this.props.enableEdit()
  }

  checkApiKey = (validate) => () => {
    const { data } = this.props
    this.props.fetchHubList(data.onFleetApiKey, validate)
  }

  onSave = () => {
    const { data, isNotLinkedApiKey } = this.props
    //const hubListValues = hubList && hubList[data.onFleetApiKey] && hubList[data.onFleetApiKey].hubResults || [];
    console.log(isNotLinkedApiKey, 'isNotLinkedApiKey')
    if (!isNotLinkedApiKey && !isValidString(data.onFleetApiKey)) {
      this.confirmModal.handleClickOpen()
      return
    }
    this.props.onChange('resetOnFleetInfo', false, () =>
      this.props.onSave((response) => {
        if (!response.onFleetInfoUpdated) {
          this.confirmModal.handleClickOpen()
        } else {
          this.props.disableEdit()
        }
      }),
    )
  }

  onConfirm = () => {
    this.props.onChange('resetOnFleetInfo', true, () => {
      const { data } = this.props
      if (!isValidString(data.onFleetApiKey)) {
        this.props.onSave(() => {
          this.props.disableEdit()
          this.confirmModal.handleClose()
        })
      } else {
        this.props.onSaveResetOnfleetInfo(data, () => {
          this.props.disableEdit()
          this.confirmModal.handleClose()
        })
      }
    })
  }

  render() {
    const { data = {}, editMode, hubList, isNotLinkedApiKey } = this.props

    const hubListValues =
      (hubList && hubList[data.onFleetApiKey] && hubList[data.onFleetApiKey].hubResults) || []
    return (
      <Fragment>
        <TableRow>
          <TableCell>{(data && data.name) || ''}</TableCell>
          <TableCell>
            <Grid container>
              <Grid item sm={10}>
                <EditableTextField
                  valueToRender={data.onFleetApiKey}
                  value={data.onFleetApiKey}
                  editMode={editMode}
                  onChange={this.onChange('onFleetApiKey')}
                />
              </Grid>
              <Grid item sm={2}>
                {editMode ? (
                  <SearchIcon
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={this.checkApiKey(true)}
                  />
                ) : null}
              </Grid>
            </Grid>
          </TableCell>
          <TableCell>
            <EditableSelect
              value={(data && data.hubId) || ''}
              valueToRender={(data && data.hubName) || ''}
              editMode={editMode}
              displayEmpty={true}
              onChange={this.onChange('hubId')}
            >
              <MenuItem value="">Select Hub</MenuItem>
              {hubListValues &&
                hubListValues.length &&
                hubListValues.map((hub, i) => {
                  return (
                    <MenuItem key={i} value={hub.id}>
                      {hub.name}
                    </MenuItem>
                  )
                })}
            </EditableSelect>
          </TableCell>
          <TableCell>
            <EditableSwitch
              valueToRender={data.enableOnFleet ? 'Enabled' : 'Disabled'}
              checked={data.enableOnFleet}
              editMode={editMode}
              onChange={this.onChange('enableOnFleet', true)}
            />
          </TableCell>

          {hasAccess() ? (
            <TableCell>
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.props.onCancel}
                onEdit={this.enableEdit}
                editMode={editMode}
                editTitle={!isNotLinkedApiKey ? 'Update' : 'Link'}
              />
            </TableCell>
          ) : null}
        </TableRow>
        <ModalDialog
          title={''}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.onConfirm}
          confirmText={'Confirm'}
          onClose={this.resetPassword}
        >
          <Typography variant="subheading" gutterBottom>
            Reset Onfleet information for shop?
          </Typography>
        </ModalDialog>
      </Fragment>
    )
  }
}

export default OnFleetShopInfoItem



// WEBPACK FOOTER //
// ./src/components/OnFleet/OnFleetShopInfoItem.js